import { Helper } from '../../Helper';
export class SetInternalObjectPropertyHelper extends Helper {
    emit(sb, node, options) {
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, sb.pushValueOptions(options), sb.helpers.getInternalObject);
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'SETITEM');
    }
}

//# sourceMappingURL=SetInternalObjectPropertyHelper.js.map
